import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'
import { prepareSearchParams } from '@/libs/helper'

const resource = `${Config.basePath}/v1/api/admin/member`
const typeId = 9

export default {
  checkUsername(username, id = null) {
    const params = {
      username,
      user_id: id,
      vvipAgent: true,
    }
    return Client.post(resource, params, {
      headers: {
        action: 'member-check-username',
      },
    })
  },
  create(payload) {
    const params = {
      ...payload,
      typeId,
      vvipAgent: true,
    }
    return Client.post(resource, params, {
      headers: {
        action: 'member-store',
      },
    })
  },
  getSuggestUsername(parentId = null, userId = null) {
    const params = {
      parentId,
      userId,
      typeId,
      vvipAgent: true,
    }
    return Client.post(resource, params, {
      headers: {
        action: 'member-suggest-username',
      },
    })
  },
  index(payload) {
    const newPayload = {
      searchFields: [
        ...payload.searchFields,
        { key: 'typeId' },
        { key: 'parentId' },
      ],
      typeId,
    }
    const params = prepareSearchParams(newPayload)
    if (payload.search) {
      params.filters.push({
        searchby: 'username',
        searchoperator: '%',
        search: payload.search.toUpperCase(),
      })
    }
    return Client.post(
      resource,
      {
        ...params,
        vvipAgent: true,
      },
      {
        headers: {
          action: 'member-list',
        },
      },
    )
  },
  options(payload) {
    const params = {
      ...payload,
      typeId,
    }
    return Client.post(resource, {
      ...params,
      vvipAgent: true,
    }, {
      headers: {
        action: 'list-all-option',
      },
    })
  },
  show(id, payload = {}) {
    const params = {
      ...payload,
      typeId,
      id,
    }
    return Client.post(resource, {
      ...params,
      vvipAgent: true,
    }, {
      headers: {
        action: 'member-show',
      },
    })
  },
  update(id, payload) {
    const params = {
      ...payload,
      typeId,
      id,
      vvipAgent: true,
    }
    return Client.post(resource, params, {
      headers: {
        action: 'member-update',
      },
    })
  },
}
